import { render, staticRenderFns } from "./QaList.vue?vue&type=template&id=4804e1e9&scoped=true&"
import script from "./QaList.vue?vue&type=script&lang=js&"
export * from "./QaList.vue?vue&type=script&lang=js&"
import style0 from "./QaList.vue?vue&type=style&index=0&id=4804e1e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804e1e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4804e1e9')) {
      api.createRecord('4804e1e9', component.options)
    } else {
      api.reload('4804e1e9', component.options)
    }
    module.hot.accept("./QaList.vue?vue&type=template&id=4804e1e9&scoped=true&", function () {
      api.rerender('4804e1e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/qa/QaList.vue"
export default component.exports